/**
 * Boxful Physical AI tech page - live data inspector (task tabs, gauges, waveform)
 * Source design: boxful_app 2/tech/ (static mockup)
 */

let currentTaskKey = "task1";
let animFrameId = null;

// Task Selector Tabs
function initTaskSelector() {
  const taskButtons = document.querySelectorAll(".task-item-btn");
  taskButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      taskButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const taskKey = btn.dataset.task;
      currentTaskKey = taskKey;
      renderInspector(taskKey);
    });
  });
}

// Render Inspector Data
function renderInspector(taskKey) {
  const data = TASK_DATASETS[taskKey];
  if (!data) return;

  // Update text metadata
  document.getElementById("liveSkuLabel").textContent = `${data.sku} (${data.category})`;
  document.getElementById("liveDuration").textContent = data.duration;
  document.getElementById("liveTimestamp").textContent = data.timestamp;

  // Update Pressure Gauges
  updateGauge("thumb", data.pressures.thumb, data.pressureVals.thumb);
  updateGauge("index", data.pressures.index, data.pressureVals.index);
  updateGauge("middle", data.pressures.middle, data.pressureVals.middle);
  updateGauge("ring", data.pressures.ring, data.pressureVals.ring);
  updateGauge("palm", data.pressures.palm, data.pressureVals.palm);

  // Update JSON Preview
  const jsonElem = document.getElementById("jsonPreviewCode");
  if (jsonElem) {
    jsonElem.textContent = JSON.stringify(data.jsonPreview, null, 2);
  }
}

function updateGauge(finger, percent, label) {
  const fill = document.getElementById(`gauge-${finger}`);
  const val = document.getElementById(`val-${finger}`);
  if (fill) fill.style.height = `${percent}%`;
  if (val) val.textContent = label;
}

// Live Waveform Canvas Simulation (IMU Trajectory)
function initWaveformCanvas() {
  const canvas = document.getElementById("waveformCanvas");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");

  let step = 0;

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw Grid Lines
    ctx.strokeStyle = "rgba(255, 255, 255, 0.05)";
    ctx.lineWidth = 1;
    for (let x = 0; x < canvas.width; x += 40) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.stroke();
    }
    for (let y = 0; y < canvas.height; y += 30) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(canvas.width, y);
      ctx.stroke();
    }

    // Accelerometer X (Mint)
    ctx.strokeStyle = "#00E699";
    ctx.lineWidth = 2;
    ctx.beginPath();
    for (let x = 0; x < canvas.width; x++) {
      const freq = currentTaskKey === 'task1' ? 0.04 : (currentTaskKey === 'task2' ? 0.07 : 0.03);
      const amp = currentTaskKey === 'task1' ? 24 : (currentTaskKey === 'task2' ? 32 : 18);
      const y = (canvas.height / 2 - 15) + Math.sin((x + step) * freq) * amp * Math.sin(x * 0.008);
      if (x === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.stroke();

    // Accelerometer Y (Cyan)
    ctx.strokeStyle = "#38bdf8";
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    for (let x = 0; x < canvas.width; x++) {
      const freq = 0.035;
      const y = (canvas.height / 2 + 10) + Math.cos((x + step * 0.8) * freq) * 20 * Math.sin((x + 20) * 0.01);
      if (x === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.stroke();

    // Grip Pressure Wave (Gold/Amber)
    ctx.strokeStyle = "#f59e0b";
    ctx.lineWidth = 1.5;
    ctx.setLineDash([4, 4]);
    ctx.beginPath();
    for (let x = 0; x < canvas.width; x++) {
      const y = (canvas.height - 25) - Math.abs(Math.sin((x + step * 0.5) * 0.02)) * 22;
      if (x === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.stroke();
    ctx.setLineDash([]); // reset

    step += 1.5;
    animFrameId = requestAnimationFrame(draw);
  }

  draw();
}
